import React from "react";
import { T } from "./tokens";
import { Chevron, DiagramShell, Layer, rowChips } from "./primitives";

const CwpArchitecture = ({ title }) => {
  const W = 840;
  const x = 28;
  const w = W - 56;
  const gap = 10;
  const chipH = 50;

  const l1 = 72;
  const l2 = 214;
  const l3 = 356;
  const l4 = 542;

  return (
    <DiagramShell
      uid="cwp"
      viewBox={`0 0 ${W} 660`}
      title="Cloud Workload Platform"
      subtitle="Console · Agent · Hardware"
      label={title}
    >
      <Layer
        x={x}
        y={l1}
        w={w}
        h={118}
        theme={T.purple}
        title="CWP CONSOLE"
      >
        {rowChips(
          [
            ["Recipes &", "Policies"],
            ["Resource Center", "Models / Tools"],
            ["Faults &", "Logs"],
            ["Live", "Monitoring"],
          ],
          { x: x + 16, y: l1 + 42, w: w - 32, h: chipH, gap, theme: T.purple }
        )}
      </Layer>
      <Chevron x={W / 2} y={l1 + 124} />

      <Layer
        x={x}
        y={l2}
        w={w}
        h={118}
        theme={T.indigo}
        title="PLATFORM SERVICES"
      >
        {rowChips(
          [
            ["Agent Control", "Heartbeat / MQ"],
            ["Assets", "Hosts / GPU / BMC"],
            ["BKBC", "Host config"],
            ["Dispatch", "Tasks / Components"],
          ],
          { x: x + 16, y: l2 + 42, w: w - 32, h: chipH, gap, theme: T.indigo }
        )}
      </Layer>
      <Chevron x={W / 2} y={l2 + 124} />

      <Layer
        x={x}
        y={l3}
        w={w}
        h={162}
        theme={T.slate}
        title="HOST AGENT  ·  BARE METAL / CONTAINERS / VMS"
      >
        <Layer
          x={x + 16}
          y={l3 + 38}
          w={(w - 42) / 2}
          h={108}
          theme={T.purple}
          title="AGENT BASE"
        >
          {rowChips(
            ["OS / Kernel", "Drivers", "Plugins", ["Workload", "Runtime"]],
            {
              x: x + 28,
              y: l3 + 72,
              w: (w - 42) / 2 - 24,
              h: 42,
              gap: 8,
              theme: T.purple,
            }
          )}
        </Layer>
        <Layer
          x={x + 26 + (w - 42) / 2}
          y={l3 + 38}
          w={(w - 42) / 2}
          h={108}
          theme={T.indigo}
          title="RUNTIME"
        >
          {rowChips(
            ["Collectors", "Workloads", "Logs", "Metrics"],
            {
              x: x + 38 + (w - 42) / 2,
              y: l3 + 72,
              w: (w - 42) / 2 - 24,
              h: 42,
              gap: 8,
              theme: T.indigo,
            }
          )}
        </Layer>
      </Layer>
      <Chevron x={W / 2} y={l3 + 168} />

      <Layer
        x={x}
        y={l4}
        w={w}
        h={88}
        theme={T.green}
        title="TARGET ENVIRONMENT"
      >
        {rowChips(
          ["GPU", "CPU / MEM", "Network", "SSD", "Kubernetes", "Slurm"],
          {
            x: x + 16,
            y: l4 + 36,
            w: w - 32,
            h: 36,
            gap: 8,
            theme: T.green,
          }
        )}
      </Layer>
    </DiagramShell>
  );
};

export default CwpArchitecture;
